/**
 * Privacy & consent copy shared by the tradie onboarding flow, the file upload
 * form and the account-settings "Privacy & consent" section. Kept in step with
 * the Flutter app (lib/views/files/widgets/file_form_consent_section.dart and
 * lib/views/profile/account_settings_screen.dart).
 */

export const CONSENT_URLS = {
  terms: 'https://cms.tradiepass.com.au/support/terms',
  privacy: 'https://cms.tradiepass.com.au/support/privacy',
  privacyCollection: 'https://cms.tradiepass.com.au/support/privacy-collection',
}

/**
 * The Privacy Collection Notice shown (expandable) next to the manual-upload
 * consent checkbox. Verbatim from the app's `_privacyNoticeText`.
 */
export const PRIVACY_COLLECTION_NOTICE = `This Privacy Collection Notice describes how Tradie Pass Pty Ltd (ABN 647 453 129) (we, us or our) collects and handles your personal information when you use or otherwise interact with any artificial intelligence verification tool provided on our platform (AI Verification Tool).

We collect personal information from you and may process your personal information through the AI Verification Tool to perform background checks and to verify the currency and validity of your documents, and for related purposes set out in our Privacy Policy, available on our website (or on request).

The personal information you input to the AI Verification Tool will not be used to train the AI model.

We may disclose this personal information to IT service providers, our personnel, related entities, and as otherwise set out in our Privacy Policy. The AI Chatbot may generate or infer information about you, which we treat as personal information.

We may disclose the outcome of the AI Verification Tool to the Companies that engage with you on the platform.

We store personal information in Australia. Where we disclose your personal information to third parties, those third parties may store, transfer or access personal information outside of Australia.

Please see our Privacy Policy for more information about how we collect, store, use and disclose your personal information.

If you have questions about our privacy practices, please contact us by email at: support@tradiepass.com.au. By providing your personal information to us, you consent to the collection, use, storage and disclosure of that information as described in this privacy collection notice.`

/**
 * The three consent types tracked on the user record. `key` is the boolean
 * field on `/auth/me`, `type` is the value posted to
 * `POST /auth/profile/accept-consent`.
 */
export const CONSENT_TYPES = [
  {
    type: 'signup',
    key: 'signup_consent_given',
    dateKey: 'signup_consent_given_at',
    label: 'Signup consent',
    description:
      'Privacy Policy, Terms & Conditions and Privacy Collection Notice',
  },
  {
    type: 'ai',
    key: 'ai_consent_given',
    dateKey: 'ai_consent_given_at',
    label: 'AI upload consent',
    description: 'Privacy Collection Notice for AI document scanning',
  },
  {
    type: 'manual_upload',
    key: 'manual_upload_consent_given',
    dateKey: 'manual_upload_consent_given_at',
    label: 'Manual upload consent',
    description: 'Privacy Collection Notice for manual file uploads',
  },
]
